<template>
  <div class="content">
    <!-- 有第三方 kyc 驗證 -->
    <div v-if="kyc_brand" class="verify-form kyc-tips">
      <p>
        <i class="icon-alert">
          <img :src="getThemeImagePath('icon_alert.png')" alt="">
        </i>
        <template v-if="memberInfo.is_pass_KYC === 1">
          {{ $t("Bao.KYC_has_third_completed") }}
        </template>
        <template v-else-if="isSetData">
          {{ $t("Bao.KYC_need_third_completed") }}
        </template>
        <template v-else>
          {{ $t("Bao.KYC_has_third_not_complete") }}
        </template>
      </p>
      <div
        v-if="memberInfo.is_pass_KYC !== 1 && isSetData"
        class="btn btn-style-primary kyc-bn-gold"
        @click="save()"
      >
        {{ $t("Bao.KYC_has_third_completed_btn") }}
      </div>
    </div>

    <ul v-if="!kyc_brand" class="kyc-tab-frame-m">
      <li class="tab-items-m kyc-tab-items-m" @click="$router.push('/user/KYC')">
        <i class="icon-arrow-back"><img :src="getThemeImagePath('home-arrow-left.png')" alt=""></i>
        {{ $t("Bao.return_KYC_page") }}
      </li>
    </ul>
    <!-- 未經過驗證 -->
    <template v-if="!kyc_brand && memberInfo.is_pass_KYC === 0">
      <div class="verify-form">
        <p>
          <i class="icon-alert">
            <img :src="getThemeImagePath('icon-alert-kyc.png')" alt="">
          </i>
          <span class="highlight">{{ $t("Bao.KYC_not_complete_1") }}</span>
          {{ $t("Bao.KYC_not_complete_2") }}
        </p>
      </div>
    </template>
    <!-- 已驗證 -->
    <template v-if="!kyc_brand && memberInfo.is_pass_KYC === 1">
      <div class="verify-form">
        <p>
          <i class="icon-alert">
            <img :src="getThemeImagePath('icon-alert-kyc.png')" alt="">
          </i>
          {{ $t("Bao.KYC_has_completed_1") }}
          <span class="highlight">{{ $t("Bao.KYC_has_completed_2") }}</span>
          {{ $t("Bao.KYC_has_completed_3") }}
          <span class="highlight"> {{ $t("Bao.KYC_has_completed_4") }}</span>
          {{ $t("Bao.KYC_has_completed_5") }}
        </p>
      </div>
    </template>

    <div class="verify-form">
      <div class="verify-form-title">
        {{ $t('Bao.personal_info') }}
      </div>

      <div class="form-box">
        <div>
          <p>
            {{ $t('Bao.last_name') }}
            <span class="highlight-input">*</span>
          </p>
          <template v-if="memberInfo.name">
            <input
              v-model="lastName"
              type="text"
              disabled
            >
          </template>
          <template v-else>
            <input
              v-model="lastName"
              v-validate="'required'"
              type="text"
              name="last_name"
              :data-vv-as="$t('Bao.last_name')"
              :placeholder="$t('Bao.name_content')"
            >
          </template>
          <small v-if="errors.has('last_name')" class="help-block">{{ $t('Bao.last_name_error') }}</small>
        </div>
        <div>
          <p>
            {{ $t('Bao.first_name') }}
            <span class="highlight-input">*</span>
          </p>
          <template v-if="memberInfo.name">
            <input
              v-model="firstName"
              type="text"
              disabled
            >
          </template>
          <template v-else>
            <input
              v-model="firstName"
              v-validate="'required'"
              type="text"
              name="first_name"
              :data-vv-as="$t('Bao.first_name')"
              :placeholder="$t('Bao.name_content')"
            >
          </template>
          <small v-if="errors.has('first_name')" class="help-block">{{ $t('Bao.first_name_error') }}</small>
        </div>
        <div>
          <p>
            {{ $t('Bao.romanization_of_last_name') }}
            <span class="highlight-input">*</span>
          </p>
          <template v-if="memberInfo.romanization">
            <input
              v-model="romanizationOfLastName"
              type="text"
              disabled
            >
          </template>
          <template v-else>
            <input
              v-model="romanizationOfLastName"
              v-validate="'required'"
              type="text"
              name="romanizationOfLastName"
              :data-vv-as="$t('Bao.romanization_of_last_name')"
              @input="validateRomLastName"
            >
          </template>
          <small v-if="errors.has('romanizationOfLastName')" class="help-block">{{ $t('Bao.romanization_of_last_name_error') }}</small>
          <small v-else-if="romanLastError" class="help-block">{{ romanLastError }}</small>
        </div>
        <div>
          <p>
            {{ $t('Bao.romanization_of_first_name') }}
            <span class="highlight-input">*</span>
          </p>
          <template v-if="memberInfo.romanization">
            <input
              v-model="romanizationOfFirstName"
              type="text"
              disabled
            >
          </template>
          <template v-else>
            <input
              v-model="romanizationOfFirstName"
              v-validate="'required'"
              type="text"
              name="romanizationOfFirstName"
              :data-vv-as="$t('Bao.romanization_of_first_name')"
              @input="validateRomFirstName"
            >
          </template>
          <small v-if="errors.has('romanizationOfFirstName')" class="help-block">{{ $t('Bao.romanization_of_first_name_error') }}</small>
          <small v-else-if="romanFirstError" class="help-block">{{ romanFirstError }}</small>
        </div>
        <div>
          <p>
            {{ $t("Bao.birthday") }}
            <span class="highlight-input">*</span>
          </p>
          <template v-if="memberInfo.birthday">
            <input
              type="text"
              :value="memberInfo.birthday"
              disabled
            >
          </template>
          <template v-else>
            <input
              v-model="updateUser.birthday"
              v-validate="'required|date_format:yyyy-MM-dd|before:' + maxDate"
              type="date"
              name="birthday"
              :data-vv-as="$t('Bao.birthday')"
              :max="maxDate"
            >
          </template>
          <small v-if="errors.has('birthday')" class="help-block">{{ $t('Bao.birthday_error') }}</small>
        </div>
        <div>
          <p>
            {{ $t("Bao.address") }}
            <span class="highlight-input">*</span>
          </p>
          <input
            v-model="updateUser.address"
            v-validate="'required'"
            type="text"
            name="address"
            :placeholder="pleaseEnterTip('address')"
            :disabled="memberInfo.is_pass_KYC === 1"
          >
          <small v-if="errors.has('address')" class="help-block">{{ $t('Bao.address_error') }}</small>
        </div>
      </div>

      <div class="verify-form-title">
        {{ $t("Bao.contact_info") }}
      </div>
      <div class="form-box">
        <div class="inline">
          <p>
            {{ $t("Bao.e-mail") }}
            <span class="highlight-input">*</span>
          </p>
          <div>
            <input
              v-if="memberInfo.email_validate === 0"
              id="eMail"
              v-model="updateUser.email"
              v-validate="'required'"
              class="form-control"
              type="email"
              name="email"
              :placeholder="memberInfo.email"
            >
            <input
              v-else
              id="eMail"
              class="form-control"
              type="text"
              name="check_lite_email"
              :value="memberInfo.email"
              :disabled="memberInfo.email_validate === 1"
            >

            <button
              :disabled="memberInfo.email_validate === 1 && !updateUser.email"
              class="btn btn-style-primary btn-settings set-email"
              @click="goVerifyEmail"
            >
              {{ $t("Bao.setting") }}
            </button>
          </div>
        </div>
      </div>
      <div class="form-box">
        <div class="inline">
          <p>
            {{ $t("Bao.phone") }}
            <span class="highlight-input">*</span>
          </p>
          <div>
            <input
              v-if="memberInfo.phone_validate === 0"
              id="phoneNumber"
              v-model="phone"
              v-validate="'required'"
              type="text"
              class="jp"
              @input="phonecheck"
            >
            <input
              v-if="memberInfo.phone_validate === 1"
              id="phoneNumber"
              :placeholder="updateUser.phone"
              type="text"
              class="jp"
              disabled
            >
            <button
              :disabled="memberInfo.phone_validate === 1 || !isPhoneValid"
              class="btn btn-style-primary btn-settings set-email"
              @click="goVerifyPhone"
            >
              {{ $t("Bao.setting") }}
            </button>
          </div>

          <div v-if="phoneError === $t('Bao.phone_available')" class="account_good">
            {{ phoneError }}
          </div>
          <div v-else-if="phoneError" class="help-block">
            {{ phoneError }}
          </div>
        </div>
      </div>

      <div class="verify-form-title">
        {{ $t("Bao.setting_password") }}
      </div>
      <div class="form-box">
        <div>
          <p>{{ $t("Bao.modify") }}{{ $t("Bao.login_password") }}</p>
          <input
            v-model="updateUser.newPassword"
            v-validate="'min:6'"
            type="password"
            :placeholder="$t('Bao.please_leave_blank_if_not_set')"
            :data-vv-as="$t('Bao.newPassword')"
            name="newPassword"
            @input="pwdCheck"
          >
          <small v-if="pwdError" class="help-block">
            {{ pwdError }}
          </small>
        </div>
        <div>
          <p>{{ $t("Bao.confirm") }}{{ $t("Bao.login_password") }}{{ $t("Bao.login_password_2") }}</p>
          <input
            v-model="updateUser.confirmPassword"
            v-validate="'min:6'"
            type="password"
            :placeholder="$t('Bao.please_leave_blank_if_not_set')"
            :data-vv-as="$t('Bao.confirmPassword')"
            name="confirmPassword"
            autocomplete="off"
          >
          <small v-if="errors.has('confirmPassword')" class="help-block">
            {{ $t("Bao.confirm_password_error") }}
          </small>
        </div>
        <div>
          <p>
            {{ $t("Bao.withdrawal_password") }}
          </p>
          <input
            v-if="memberInfo.withdrawal_pass === ''"
            v-model="updateUser.withdrawal_pass"
            v-validate="'required|min:4|max:4|integer'"
            type="password"
            :placeholder="pleaseEnterTip('withdrawal_pass')"
            :data-vv-as="$t('Bao.withdrawal_pass')"
            name="withdrawal_pass"
            maxlength="4"
          >
          <input
            v-else
            v-model="updateUser.withdrawal_pass"
            v-validate="'min:4|max:4|integer'"
            type="password"
            :placeholder="pleaseEnterTip('withdrawal_pass')"
            :data-vv-as="$t('Bao.withdrawal_pass')"
            name="withdrawal_pass"
            maxlength="4"
          >
          <small v-if="errors.has('withdrawal_pass')" class="help-block">
            {{ $t('Bao.withdrawal_password_limit_error') }}
          </small>
        </div>
      </div>
    </div>
    <div class="btnframe">
      <button
        :disabled="isSendButtonDisabled"
        class="btn btn-kyc"
        @click="save()"
      >
        <span>
          <template v-if="kyc_brand && memberInfo.is_pass_KYC !== 1">
            {{ $t("Bao.KYC_has_third_completed_btn") }}
          </template>
          <template v-else>
            {{ memberInfo.is_pass_KYC === 0 ? $t("Bao.next") : $t("Bao.save_setting") }}
          </template>
        </span>
      </button>
    </div>

    <!-- 驗證彈窗 -->
    <div
      v-if="isShowVerifyEmail || isShowVerifyPhone"
      class="popup-wrap register-wrap fun-sec-authen"
      :class="{ active: isShowVerifyEmail || isShowVerifyPhone }"
    >
      <div class="popup-box fullScreen-md">
        <a class="popup-close" @click="closeVerify" />
        <div class="form-popup popup-padding">
          <form class="row-frame dep-form-frame colu-12 reg-popupBox">
            <h4 class="register-title font-w-b text-align-L">
              <template v-if="isShowVerifyEmail">
                {{ $t("Bao.verify_email") }}
              </template>
              <template v-if="isShowVerifyPhone">
                {{ $t("Bao.verify_phone") }}
              </template>
            </h4>
            <div class="reg-form-group">
              <div class="reg-form-area">
                <div class="colu colu-auto">
                  <label class="colu-12 colu-form-label title-label let-lessen">
                    <template v-if="isShowVerifyEmail">
                      {{ $t("Bao.verify_email_code") }}
                    </template>
                    <template v-if="isShowVerifyPhone">
                      {{ $t("Bao.verify_phone_code") }}
                    </template>
                  </label>
                  <div class="colu-12">
                    <input
                      v-if="isShowVerifyEmail"
                      v-model="verifyEmailCode"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': shouldShowEmailError}"
                      type="text"
                      name="emailValidateCode"
                      autocomplete="off"
                      @input="validateEmailCode"
                    >
                    <input
                      v-if="isShowVerifyPhone"
                      v-model="verifyPhoneCode"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': shouldShowPhoneError}"
                      type="text"
                      name="phoneValidateCode"
                      autocomplete="off"
                      @input="validatePhoneCode"
                    >
                  </div>
                  <div v-if="shouldShowEmailError || shouldShowPhoneError" class="input-feedback text-align-R">
                    {{ $t("Bao.validate_code_error") }}
                  </div>
                </div>
                <div>
                  <div class="form-button">
                    <button
                      class="button-style-7"
                      :disabled="isShowVerifyEmail ? isMailButtonDisabled : isPhoneButtonDisabled"
                      @click.prevent="isShowVerifyEmail ? verifyMail() : verifyPhone()"
                    >
                      <span>{{ $t("Bao.verify_register") }}</span>
                    </button>
                  </div>
                </div>
                <div class="colu-auto">
                  <i class="icon-alert">
                    <img :src="getThemeImagePath('icon-detail.png')" alt="">
                  </i>
                  <b>{{ $t("Bao.email_notice_4") }}</b>
                  <span v-if="isShowVerifyEmail" class="let-lessen">{{ $t("Bao.email_notice_5") }}</span>
                  <span v-if="isShowVerifyPhone" class="let-lessen">{{ $t("Bao.phone_notice_5") }}</span>
                </div>
                <div class="colu-auto">
                  <b>{{ $t("Bao.email_notice_1") }}</b>
                </div>
                <div class="colu-auto">
                  <p v-if="isShowVerifyEmail">
                    {{ $t("Bao.email_notice_2") }} {{ $t("Bao.email_notice_3") }}
                  </p>
                  <p v-if="isShowVerifyPhone">
                    {{ $t("Bao.phone_notice_3") }}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <div class="authen-btn-wrap">
                <button
                  class="btn-primary-gold goTo-fun-sec-authen btn-mb-w-100 btn-resend"
                  :disabled="timerCount"
                  @click="getVerificationPop"
                >
                  <i v-show="timerCount" class="fa fa-spinner fa-pulse fa-fw" />
                  <span>{{ timerCount ? '' + limitSecond + 's' : $t('Bao.get_verification_code') }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <iframe-verify v-if="verifyUrlFromStore" />
  </div>
</template>

<script>
import { update, getPhoneCode, verifyPhoneCode, getEmailCode, verifyEmailCode, phoneCheck, getThirdPartyKycUrl } from '@/api/user'
import { setErrorMessage, showNotice, getThemeImagePath } from '@/utils/tool'
import iframeVerify from '@/components/modal/iframeGame'

export default {
  components: {
    iframeVerify
  },
  data() {
    return {
      isShowVerify: false,
      updateUser: {},
      romanizationOfLastName: '',
      romanizationOfFirstName: '',
      romanLastError: '',
      romanFirstError: '',
      lastName: '',
      firstName: '',
      maxDate: new Date().toISOString().split('T')[0],
      isShowVerifyPhone: false,
      phone: '',
      verifyPhoneCode: '',
      isShowVerifyEmail: false,
      email: '',
      verifyEmailCode: '',
      timerCount: true,
      limitSecond: 180,
      isPhoneValid: false,
      phoneError: '',
      formattedPhone: '',
      isPwdValid: true,
      pwdError: '',
      emailCodeTouched: false,
      phoneCodeTouched: false
    }
  },
  computed: {
    kyc_brand() {
      return this.$store.state.brand.info.kyc_brand !== 'self'
    },
    user() {
      return this.$store.getters.user
    },
    memberInfo() {
      return this.user.memberInfo
    },
    isSendButtonDisabled() {
      return this.memberInfo.email_validate === 0 || this.memberInfo.phone_validate === 0
    },
    isMailButtonDisabled() {
      return this.verifyEmailCode === null || this.verifyEmailCode.trim() === ''
    },
    isPhoneButtonDisabled() {
      return this.verifyPhoneCode === null || this.verifyPhoneCode.trim() === ''
    },
    verifyUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    isSetData() {
      return this.memberInfo.name !== '' && this.memberInfo.romanization !== '' &&
             this.memberInfo.birthday !== '' && this.memberInfo.address !== '' &&
             this.memberInfo.email_validate === 1 &&
             this.memberInfo.phone_validate === 1 &&
             this.memberInfo.withdrawal_pass !== ''
    },
    emailCodeInvalid() {
      return this.verifyEmailCode.trim() === ''
    },
    phoneCodeInvalid() {
      return this.verifyPhoneCode.trim() === ''
    },
    shouldShowEmailError() {
      return this.emailCodeTouched && this.emailCodeInvalid
    },
    shouldShowPhoneError() {
      return this.phoneCodeTouched && this.phoneCodeInvalid
    }
  },
  watch: {
    romanizationOfLastName(newLastName) {
      this.updateUser.romanization = newLastName + ',' + this.romanizationOfFirstName
    },
    romanizationOfFirstName(newFirstName) {
      this.updateUser.romanization = this.romanizationOfLastName + ',' + newFirstName
    },
    lastName(newLastName) {
      this.updateUser.name = newLastName + ',' + this.firstName
    },
    firstName(newFirstName) {
      this.updateUser.name = this.lastName + ',' + newFirstName
    }
  },
  created() {
    this.initUpdateUser()
    this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)
  },
  methods: {
    openIframe() {
      const kyc_url = this.$store.state.user.kyc_url
      if (kyc_url) {
        this.$store.commit('SET_GAME_URL', kyc_url)
        this.$store.commit('SET_KYC_VERIFY', true)
      } else {
        getThirdPartyKycUrl().then(response => {
          if (response.data.data.code === 0) {
            this.$store.commit('SET_GAME_URL', response.data.data.url)
            this.$store.commit('SET_KYC_VERIFY', true)
          } else {
            showNotice(response.data.data.message)
          }
        }).catch((error) => {
          showNotice(error.response.data.msg)
        })
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    pwdCheck() {
      const newPassword = this.updateUser.newPassword
      if (newPassword && newPassword.trim() !== '') {
        const passwordRegex = /^[a-zA-Z0-9]+$/ // Regex to allow only letters (uppercase and lowercase) and numbers
        if (!passwordRegex.test(newPassword)) {
          this.pwdError = this.$t('Bao.password_restrict_chars')
          this.isPwdValid = false
        } else if (newPassword.length < 6) {
          this.pwdError = this.$t('Bao.password_restrict')
          this.isPwdValid = false
        } else if (newPassword.length > 20) {
          this.pwdError = this.$t('Bao.password_restrict_20')
          this.isPwdValid = false
        } else {
          this.pwdError = ''
          this.isPwdValid = true
        }
      }
    },
    initUpdateUser() {
      this.romanizationOfLastName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[0] : ''
      this.romanizationOfFirstName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[1] : ''
      this.lastName = this.memberInfo.name ? this.memberInfo.name.split(',')[0] : ''
      this.firstName = this.memberInfo.name ? this.memberInfo.name.split(',')[1] : ''

      this.updateUser = {
        romanization: this.memberInfo.romanization,
        name: this.memberInfo.name,
        newPassword: '',
        confirmPassword: '',
        withdrawal_pass: '',
        address: this.memberInfo.address,
        birthday: this.memberInfo.birthday,
        phone: this.memberInfo.phone ? `0${this.memberInfo.phone.substring(3)}` : ''
      }
    },
    phoneApiCall() {
      this.formattedPhone = `+81${this.phone.substring(1)}`
      if (this.phone && this.phone.trim() !== '') {
        phoneCheck({ phone: this.formattedPhone }).then(res => {
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.log(err)
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    phonecheck() {
      const phoneRegex = /^0\d{10}$/ // Regular expression for phone format: starts with 0 and has 10 digits in total
      if (!this.phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else if (!phoneRegex.test(this.phone)) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
        }
      }, 1000)
    },
    getVerificationPop() {
      if (this.isShowVerifyEmail) {
        this.goVerifyEmail()
        return
      } else {
        this.goVerifyPhone()
      }
    },
    closeVerify() {
      this.isShowVerifyEmail = false
      this.isShowVerifyPhone = false
    },
    goVerifyPhone() {
      this.isShowVerifyPhone = true
      this.getPhoneCode(this.formattedPhone)
    },
    getPhoneCode(num) {
      getPhoneCode({ phone: num }).then(response => {
        this.countDown()
        showNotice(response.data.msg)
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    verifyPhone() {
      verifyPhoneCode({ phone: this.formattedPhone, validateCode: this.verifyPhoneCode }).then(response => {
        this.isShowVerifyPhone = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.initUpdateUser()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    goVerifyEmail() {
      if (!this.updateUser.email && this.memberInfo.email) {
        this.updateUser.email = this.memberInfo.email
      }

      this.email = this.updateUser.email
      this.getMailCode(this.email)
    },
    getMailCode(mail) {
      getEmailCode({ email: mail }).then(response => {
        this.isShowVerifyEmail = true
        this.countDown()
        showNotice(response.data.msg)
      }).catch((error) => {
        showNotice(error.response.data.msg)
        this.isShowVerifyEmail = false
      })
    },
    verifyMail() {
      verifyEmailCode({ email: this.email, validateCode: this.verifyEmailCode }).then(response => {
        this.isShowVerifyEmail = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.initUpdateUser()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    save() {
      // lite player 只需輸入提款密碼即可保存
      if (this.memberInfo.member_type === 3) {
        this.updateUser.email = this.email
        this.updateUser.phone = this.formattedPhone || this.formatPhoneNumber(this.updateUser.phone)
        update(this.updateUser).then(response => {
          showNotice(this.$t('Bao.update_success'))
          this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
          this.initUpdateUser()
        }).catch((error) => {
          setErrorMessage(error.response, this.errors)
        })
      } else {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.updateUser.email = this.email
            this.updateUser.phone = this.formattedPhone || this.formatPhoneNumber(this.updateUser.phone)

            update(this.updateUser).then(response => {
              if (this.memberInfo.is_pass_KYC === 1) {
                showNotice(this.$t('Bao.update_success'))
              } else if (this.kyc_brand && this.memberInfo.is_pass_KYC !== 1) {
                this.openIframe()
              } else if (!this.kyc_brand) {
                this.$router.push('/user/KYC')
              }

              this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
              this.initUpdateUser()
            }).catch((error) => {
              setErrorMessage(error.response, this.errors)
            })
          }
        })
      }
    },
    pleaseEnterTip(filed) {
      return this.$t('Bao.' + filed) + '/' + this.$t('Bao.please_input')
    },
    formatPhoneNumber(input) {
      if (process.env.VUE_APP_CURRENCY === 'JPY') {
        const regex = /^(\+81 )?\d{2}-\d{4}-\d{4}$/
        if (regex.test(input)) {
          return input // Return the original number if it's already correctly formatted
        }
        let str = '' + input
        // If the phone number starts with a '0', remove the '0'
        if (str.startsWith('0')) {
          str = str.substring(1)
        }
        // Add the country code and hyphens
        return '+81 ' + str.slice(0, 2) + '-' + str.slice(2, 6) + '-' + str.slice(6)
      } else {
        return input
      }
    },
    isKatakana(str) {
      return /^[\u30A0-\u30FF\u31F0-\u31FF]*$/.test(str)
    },
    validateRomLastName() {
      if (!this.isKatakana(this.romanizationOfLastName)) {
        this.romanLastError = this.$t('Bao.katakana_only')
      } else if (this.isKatakana(this.romanizationOfLastName)) {
        this.romanLastError = ''
      }
    },
    validateRomFirstName() {
      if (!this.isKatakana(this.romanizationOfFirstName)) {
        this.romanFirstError = this.$t('Bao.katakana_only')
      } else if (this.isKatakana(this.romanizationOfFirstName)) {
        this.romanFirstError = ''
      }
    },
    getThemeImagePath,
    validateEmailCode() {
      this.emailCodeTouched = true
    },
    validatePhoneCode() {
      this.phoneCodeTouched = true
    }
  }
}
</script>
